import {SubsidiaryDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'DELETE_SUBSIDIARY';

export async function deleteSubsidiary(
    userData: Record<string, string>,
    subsidiaryId: number
) {
    try {
        const result = await SubsidiaryDao.deleteSubsidiary(userData.userToken, subsidiaryId);

        return result;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
